import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { SeparacaoEdit } from '@/features/separacao/page/edit/SeparacaoEdit';
import { validateRoute } from '@/router/util';
import { StringToIdpkSchema } from '@/std/schema';

const SeparacaoEditParamsSchema = z.object({
    idpk: StringToIdpkSchema,
    type: z.enum(['separação', 'conferência']),
});

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/separacao/$type/$idpk')({
    params: {
        parse: (params) => {
            const result = SeparacaoEditParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    beforeLoad: ({ params }) => {
        validateRoute({
            fintech: false,
            validatePermission: (permissions) => {
                if (isPermissionParcialOrFull(permissions.upp_logistica)) {
                    return true;
                }

                if (params.type === 'separação') {
                    return isPermissionParcialOrFull(permissions.upp_logistica_separacao);
                }

                if (params.type === 'conferência') {
                    return isPermissionParcialOrFull(permissions.upp_logistica_conferencia);
                }

                return false;
            },
        });
    },
    component: Component,
});

function Component() {
    const { idpk, type } = Route.useParams();

    return <SeparacaoEdit idpk={idpk} type={type} />;
}
